import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockLookupRead } from "../../mock/lookup/LookupRead";
import { GetMockLookupList } from "../../mock/lookup/LookupList";

export const useLookupDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetLookup = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockLookupRead());
      } else {
        globalFunctions
          .CallPortalApi("Lookup/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetLookupList = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockLookupList());
      } else {
        globalFunctions
          .CallPortalApi("Lookup/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              console.log(response);
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetLookup, GetLookupList };
};
